// 這是Webpack掛載起始點
import Index from './index.vue'
import New from '@core_waybills/.components/provider/new.vue'
import Edit from '@core_waybills/.components/provider/edit.vue'

const main_router = 'core_waybills'
const new_router = 'new_core_waybill'
const edit_router = 'edit_core_waybill'
const operation_main_router = 'core_waybills_operation'

const router = [
    {
        path: '',
        component: Index,
        name: 'core_waybills',
        meta: {
            api_name: "api_v1_provider_core_waybills",
            breadcrumb: [main_router],
            btns: [new_router]
        },
    },
    {
        path: 'new',
        component: New,
        name: 'new_core_waybill',
        meta: {
            api_name: "api_v1_provider_core_waybill_create",
            breadcrumb: [main_router, new_router]
        }
    },
    {
        path: 'edit/:identity',
        component: Edit,
        name: 'edit_core_waybill',
        meta: {
            api_name: "api_v1_provider_core_waybill_update",
            breadcrumb: [main_router, edit_router]
        }
    },
    {
        // 訂單內的運單
        path: 'operation/:operation_number',
        component: Index,
        name: 'core_waybills_operation',
        meta: {
            api_name: "api_v1_provider_core_waybills",
            breadcrumb: [main_router, operation_main_router]
        }
    },
    {
        path: 'operation/:operation_number/edit/:identity',
        component: Edit,
        name: 'edit_core_waybill_operation',
        meta: {
            api_name: "api_v1_provider_core_waybill_update",
            breadcrumb: [main_router, operation_main_router, edit_router]
        }
    },
]

export default router
